import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { Header } from './Header';
import { ProfileHeaderMobile } from './MobileView/ProfileHeaderMobile';
import { CollectionNavigation } from '../MainFrame/CollectionNavigation';

const HeaderLayout: React.FC<{ displaySearch?: boolean }> = (props) => {
    const { displaySearch } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {isMobile && <ProfileHeaderMobile displaySearch={displaySearch} />}
            {!isMobile && (
                <>
                    <Header displaySearch={displaySearch} />
                    {displaySearch && <CollectionNavigation />}
                </>
            )}
        </>
    );
};

export default React.memo(HeaderLayout);
